import { createGqlQuery } from '../fetcher';
import { Job } from '../queries/job.query';
import type * as Types from '../types';

export const useJobQuery = createGqlQuery<Types.JobQueryVariables, Types.JobQuery>(
  (variables) => ['job', variables],
  Job,
);
